import type { ReactNode } from "react"

import { MemoryCandidate } from "@/components/MemoryCandidate/MemoryCandidate"

/**
 * Parses [MEMORY_CANDIDATE]...[/MEMORY_CANDIDATE] tags in markdown content
 * and replaces them with MemoryCandidate components
 */
export function parseMemoryCandidates(content: string): ReactNode[] {
  const pattern = /\[MEMORY_CANDIDATE\](.*?)\[\/MEMORY_CANDIDATE\]/gi
  const parts: ReactNode[] = []
  let lastIndex = 0
  let match
  let keyCounter = 0

  // Find all memory candidate tags
  while ((match = pattern.exec(content)) !== null) {
    // Add text before the tag
    if (match.index > lastIndex) {
      const textBefore = content.substring(lastIndex, match.index)
      if (textBefore) {
        parts.push(textBefore)
      }
    }

    // Add MemoryCandidate component
    const memoryText = match[1].trim()
    if (memoryText) {
      parts.push(<MemoryCandidate key={`memory-${keyCounter++}`} text={memoryText} />)
    }

    lastIndex = pattern.lastIndex
  }

  // Add remaining text after last tag
  if (lastIndex < content.length) {
    const textAfter = content.substring(lastIndex)
    if (textAfter) {
      parts.push(textAfter)
    }
  }

  // If no memory candidates found, return original content
  if (parts.length === 0) {
    return [content]
  }

  return parts
}

/**
 * Checks if content contains memory candidate tags
 */
export function hasMemoryCandidates(content: string): boolean {
  const pattern = /\[MEMORY_CANDIDATE\].*?\[\/MEMORY_CANDIDATE\]/gi
  return pattern.test(content)
}
